import React from "react";

import qs from "qs";

import { useForgotFlow } from "../hooks";
import { handleCurrentState } from "./handleCurrentState";
import forgotChallengeQuestionComponents from "./steps";

const ForgotChallengeQuestions = props => {
  const params = qs.parse(window.location.search.substr(1));

  const { forgotFlowState, setForgotFlowState, onSubmit } = useForgotFlow(
    handleCurrentState,
    { params }
  );

  const Component = forgotChallengeQuestionComponents[forgotFlowState.state];

  if (!Component) {
    return null;
  }

  return (
    <Component
      onSubmit={onSubmit}
      forgotFlowState={forgotFlowState}
      setForgotFlowState={setForgotFlowState}
      onCancelRoute={"/app"}
    />
  );
};

export default ForgotChallengeQuestions;



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/ForgotChallengeQuestions.js